import Mutations from '../../odata/mutations';

export default { ...new Mutations('productPurchasePrice'), ...new Mutations('productPurchasePrices') };
